import { render, staticRenderFns } from "./StatsCounter.vue?vue&type=template&id=73c00dcb&scoped=true"
import script from "./StatsCounter.vue?vue&type=script&lang=js"
export * from "./StatsCounter.vue?vue&type=script&lang=js"
import style0 from "./StatsCounter.vue?vue&type=style&index=0&id=73c00dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c00dcb",
  null
  
)

export default component.exports